import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Input, ListGroup} from "reactstrap";
import QuestionContainer from "../../Components/questionContainer";
import AnswerContainer from "../../Components/answerContainer";
import TextareaAutosize from 'react-textarea-autosize';
import ResizableTextarea from "../../Components/resizableTextarea";
import _ from "lodash";

class PresentationTypeInput extends Component {
  validate(){
    let validate = {
      valid: true,
      errors: []
    };

    return validate;
  }

  render() {
    const {value, question, onChange, validate, resize, rows} = this.props;

    return <QuestionContainer classes={"mr-2"} answersColumns={1} component={
      <ResizableTextarea
        isError={(!_.isNull(validate) && validate.errors.length > 0)}
        answer={question}
        onChange={onChange}
        value={value}
        rows={rows ? rows : 1}
        resize={resize ? resize : false}
      />
    } />
  }
}

PresentationTypeInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect(null, null, null, {withRef: true, forwardRef: true})(PresentationTypeInput);